import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3, MARKETMULTITOKEN } from '../constants/bakery/nft'

export function userMarketType(nftType: string, level: string) {
  let marketType = ''
  if (level === 'v1') {
    switch (nftType) {
      case '1':
        marketType = MARKETTYPEV1.BTCARTWORKV1
        break
      case '2':
        marketType = MARKETTYPEV1.BINANCENFTV1
        break
      case '3':
        marketType = MARKETTYPEV1.BAKERYARTWORKV1
        break
      case '4':
        marketType = MARKETTYPEV1.MUSKDOGEV1
        break
      case '5':
        marketType = MARKETTYPEV1.MEMEV1
        break
      case '6':
        marketType = MARKETTYPEV1.SEASCAPEV1
        break
      case '7':
        marketType = MARKETTYPEV1.TKONFTV1
        break
      case '8':
        marketType = MARKETTYPEV1.ONEINCHV1
        break
      case '100':
        marketType = MARKETTYPEV1.BAKERYSOCCERV1
        break
      case '101':
        marketType = MARKETTYPEV1.SFPARTWORKV1
        break
      case '105':
        marketType = MARKETTYPEV1.LOVEV1
        break
      case '108':
        marketType = MARKETTYPEV1.BARKNFTV1
        break
      case '109':
        marketType = MARKETTYPEV1.YOOSHINFTV1
        break
      case '111':
        marketType = MARKETTYPEV1.BAKERYBSCARTWORKV1
        break
      case 'weapon':
        marketType = MARKETTYPEV1.WEAPONNFTV1
        break
      case 'pet':
        marketType = MARKETTYPEV1.PETNFTV1
        break
      case 'petEgg':
        marketType = MARKETTYPEV1.EGGNFTV1
        break
      case 'combo':
        marketType = MARKETTYPEV1.DISHV1
        break
    }
  } else if (level === 'v2') {
    switch (nftType) {
      case '1':
        marketType = MARKETTYPE.BTCARTWORK
        break
      case '2':
        marketType = MARKETTYPE.BINANCENFT
        break
      case '3':
        marketType = MARKETTYPE.BAKERYARTWORK
        break
      case '4':
        marketType = MARKETTYPE.MUSKDOGE
        break
      case '5':
        marketType = MARKETTYPE.MEME
        break
      case '6':
        marketType = MARKETTYPE.SEASCAPE
        break
      case '7':
        marketType = MARKETTYPE.TKONFT
        break
      case '8':
        marketType = MARKETTYPE.ONEINCH
        break
      case '100':
        marketType = MARKETTYPE.BAKERYSOCCER
        break
      case '101':
        marketType = MARKETTYPE.SFPARTWORK
        break
      case '105':
        marketType = MARKETTYPE.LOVE
        break
      case '104':
        marketType = MARKETTYPE.DOGGYNFT
        break
      case '103':
        marketType = MARKETTYPE.CARNFT
        break
      case '106':
        marketType = MARKETMULTITOKEN.POKERMULTITOKEN
        break
      case '108':
        marketType = MARKETTYPE.BARKNFT
        break
      case '109':
        marketType = MARKETTYPE.YOOSHINFT
        break
      case '107':
        marketType = [MARKETMULTITOKEN.RACAMULTITOKEN, MARKETTYPE.RACANFT].join(",")
        break
      case '110':
        marketType = MARKETTYPE.BONDLYNFT
        break
      case '111':
        marketType = MARKETTYPE.BAKERYBSCARTWORK
        break
      case '112':
        marketType = MARKETMULTITOKEN.TOKAUMULTITOKEN
        break
      case '113':
        marketType = MARKETMULTITOKEN.MATRIXMULTITOKEN
        break
      case '114':
        marketType = MARKETMULTITOKEN.EQUIPMENTMULTITOKEN
        break
      case '115':
        marketType = MARKETMULTITOKEN.TOYMULTITOKEN
        break
      case '116':
        marketType = MARKETMULTITOKEN.KAKAMULTITOKEN
        break
      case '117':
        marketType = MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN
        break
      case 'weapon':
        marketType = MARKETTYPE.WEAPONNFT
        break
      case 'pet':
        marketType = MARKETTYPE.PETNFT
        break
      case 'petEgg':
        marketType = MARKETTYPE.EGGNFT
        break
      case 'combo':
        marketType = MARKETTYPE.DISH
        break
    }
  } else if (level === 'v3') {
    switch (nftType) {
      case 'weapon':
        marketType = MARKETTYPEV3.WEAPONNFTV3
        break
      case 'pet':
        marketType = MARKETTYPEV3.PETNFTV3
        break
      case 'petEgg':
        marketType = MARKETTYPEV3.EGGNFTV3
        break
      case 'combo':
        marketType = MARKETTYPEV3.DISHV3
        break
      case '1':
        marketType = MARKETTYPEV3.BTCARTWORKV3
        break
      case '2':
        marketType = MARKETTYPEV3.BINANCENFTV3
        break
      case '3':
        marketType = MARKETTYPEV3.BAKERYARTWORKV3
        break
      case '4':
        marketType = MARKETTYPEV3.MUSKDOGEV3
        break
      case '5':
        marketType = MARKETTYPEV3.MEMEV3
        break
      case '6':
        marketType = MARKETTYPEV3.SEASCAPEV3
        break
      case '7':
        marketType = MARKETTYPEV3.TKONFTV3
        break
      case '8':
        marketType = MARKETTYPEV3.ONEINCHV3
        break
      case '100':
        marketType = MARKETTYPEV3.BAKERYSOCCERV3
        break
      case '101':
        marketType = MARKETTYPEV3.SFPARTWORKV3
        break
      case '104':
        marketType = MARKETTYPEV3.DOGGYNFTV3
        break
      case '103':
        marketType = MARKETTYPEV3.CARNFTV3
        break
      case '105':
        marketType = MARKETTYPEV3.LOVEV3
        break
      case '106':
        marketType = MARKETTYPEV3.POKERCARDV3
        break
      case '108':
        marketType = MARKETTYPEV3.BARKNFTV3
        break
      case '109':
        marketType = MARKETTYPEV3.YOOSHINFTV3
        break
      case '107':
        marketType = MARKETTYPEV3.RACANFTV3
        break
      case '110':
        marketType = MARKETTYPEV3.BONDLYNFTV3
        break
      case '111':
        marketType = MARKETTYPEV3.BAKERYBSCARTWORKV3
        break
      case '112':
        marketType = MARKETTYPEV3.TOKAUV3
        break
      case '113':
        marketType = MARKETTYPEV3.MATRIXV3
        break
      case '114':
        marketType = MARKETTYPEV3.EQUIPMENTV3
        break
      case '115':
        marketType = MARKETTYPEV3.TOYV3
        break
      case '116':
        marketType = MARKETTYPEV3.KAKAV3
        break
      case '117':
        marketType = MARKETTYPEV3.BAKEMUSKV3
        break
      case '118':
        marketType = MARKETTYPEV3.MUSKUSMLANDNFTV3
        break
      case '119':
        marketType = MARKETTYPEV3.BLINV3
        break
      case '121':
        marketType = MARKETTYPEV3.BINAMONV3
        break
      case '120':
        marketType = MARKETTYPEV3.GAV3
        break
      case '122':
        marketType = MARKETTYPEV3.KTAV3
        break
      case '123':
        marketType = MARKETTYPEV3.KRBV3
        break
      case '124':
        marketType = MARKETTYPEV3.KRIPTOMONV3
        break
    }
  }
  return marketType
}


